import { render, staticRenderFns } from "./OtherList.vue?vue&type=template&id=d9c67dca&scoped=true&"
import script from "./OtherList.vue?vue&type=script&lang=js&"
export * from "./OtherList.vue?vue&type=script&lang=js&"
import style0 from "./OtherList.vue?vue&type=style&index=0&id=d9c67dca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c67dca",
  null
  
)

export default component.exports